/// <reference types="@types/googlemaps" />
//import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY } from '@angular/cdk/overlay/typings/overlay-directives';
import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  OnInit,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
    selector: "AutocompleteComponent",
    template: `
    <input
      class="input"
      type="text"
      placeholder="Facility Address"
      [(ngModel)]="autocompleteInput"
      #addresstext
      class="address-input"
    />
  `,
    standalone: false
})
export class AutocompleteComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() adressType: string;
  @Input() address: string;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild("addresstext") addresstext: any;

  autocompleteInput: string;
  queryWait: boolean;

  constructor() {}

  ngOnInit() {
    //console.log("child get address: " + this.address);

    this.autocompleteInput = this.address;
  }

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["address"]) {
      this.autocompleteInput = this.address;
    }
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addresstext.nativeElement,
      {
        //componentRestrictions: { country: ['US', 'CA'] },
        types: [this.adressType], // 'establishment' / 'address' / 'geocode'
      }
    );
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }
}
